export default __webpack_public_path__ + "static/media/Intro Linda.79e419f6.mp3";